import _ from 'lodash';

import React from 'react';

import LabelV2 from 'components/LabelV2';

import {SelectedRoomReview} from './components';

import './styles.css';

interface RoomPurposeProps {
  id: number;
  purpose: string;
  startDate: string;
  endDate: string | null;
}

interface RoomProps {
  roomId: number;
  roomNumber: string;
  floor: string;
  label: string;
  dummy: boolean;
  roomType: {
    name: string;
    ref: string;
  };
  roomTypeGroup: string;
  purposes: Array<RoomPurposeProps>;
}
interface SelectedRoomsReviewSectionProps {
  roomsForRoomPurposesDashboard: Array<RoomProps>;
  selectedRooms: Array<RoomProps>;
  selectRoom?: any;
  deselectNumberOfRooms?: any;
  isEditable: boolean;
}

class SelectedRoomsReviewSection extends React.Component<
  SelectedRoomsReviewSectionProps
> {
  /*
  This function gets the entire floors for the rooms that are selected
  in the following format:

  {
    4: [{roomId:1, roomNumber: 'Room-4.1'}, {roomId:2, roomNumber: 'Room-4.2'}, ...],
    5: ....
  }
  */
  getEntireFloors = (selectedRooms, allRooms) => {
    const roomsByFloors = _.groupBy(allRooms, (room: RoomProps) => room.floor);

    const selectedRoomsGroupByFloors = _.groupBy(
      selectedRooms,
      (room: RoomProps) => room.floor
    );

    const entireFloors = _.pickBy(
      selectedRoomsGroupByFloors,
      (selectedRoomfForFloor, floor) => {
        return selectedRoomfForFloor.length == roomsByFloors[floor].length;
      }
    );

    return entireFloors;
  };

  /*
  This function returns grouped rooms in the follwing format

  {
   Standard: [
    {roomId:1, roomNumber: 'Room-4.1'}, {roomId:2, roomNumber: 'Room-4.2'}...
   ],
   Cosy: [
    {'floor':roomFloor, rooms=[{roomId:14, roomNumber: 'Room-4.5'}, {roomId:2, roomNumber: 'Room-4.2'}...]} //in cases when entire floor is selected
   ],
   Comfy: [
    {'floor':roomFloor, rooms=[{roomId:14, roomNumber: 'Room-4.5'}, {roomId:2, roomNumber: 'Room-4.2'}...]}, {roomId:1, roomNumber: 'Room-4.1'}
   ]
  }

  */
  getSelectedRoomsGroupedByRoomTypeGroup = () => {
    const {roomsForRoomPurposesDashboard, selectedRooms} = this.props;

    const roomsGroupedByRoomTypeGroup: any = _.groupBy(
      selectedRooms,
      (room: RoomProps) => room.roomTypeGroup
    );

    const roomsWithGroupedFloors = _.map(
      roomsGroupedByRoomTypeGroup,
      (roomsForRoomTypeGroup, roomTypeGroup) => {
        const allRoomsForRoomTypeGroup = roomsForRoomPurposesDashboard.filter(
          room => room.roomTypeGroup === roomTypeGroup
        );

        const roomsForRoomTypeGroupAndForEntireFloors = this.getEntireFloors(
          roomsForRoomTypeGroup,
          allRoomsForRoomTypeGroup
        );

        let labelsForEntireFloors: any = [];
        if (!_.isEmpty(roomsForRoomTypeGroupAndForEntireFloors)) {
          _.map(roomsForRoomTypeGroupAndForEntireFloors, (rooms, floor) => {
            labelsForEntireFloors = [
              ...labelsForEntireFloors,
              {floor: floor, rooms: rooms}
            ];
          });
        }

        const roomsForEntireFloors = _.flatten(
          _.values(roomsForRoomTypeGroupAndForEntireFloors)
        );

        const roomsNumbersForNonEntireFloors = roomsForRoomTypeGroup.filter(
          roomForRoomTypeGroup =>
            !roomsForEntireFloors.includes(roomForRoomTypeGroup)
        );

        return {
          [roomTypeGroup]: [
            ...labelsForEntireFloors,
            ...roomsNumbersForNonEntireFloors
          ]
        };
      }
    );
    return roomsWithGroupedFloors;
  };

  removeSingleRoom = room => {
    this.props.selectRoom(false, room.roomId);
  };

  render() {
    const {
      roomsForRoomPurposesDashboard,
      selectedRooms,
      isEditable
    } = this.props;

    const entireFloors = this.getEntireFloors(
      selectedRooms,
      roomsForRoomPurposesDashboard
    );

    const selectedRoomsGroupedByRoomTypeGroups = this.getSelectedRoomsGroupedByRoomTypeGroup();
    return (
      <div className="SelectedRoomsReviewSection">
        <LabelV2>1. Review Selected Rooms</LabelV2>
        <div className="SelectedRoomsReviewSection__sections">
          <div className="SelectedRoomsReviewSection__sections__entireFloors">
            <LabelV2>Entire floors</LabelV2>
            <div className="entireFloors__floors">
              {_.map(entireFloors, (rooms, floor) => {
                const label = `Floor ${floor}`;
                return (
                  <SelectedRoomReview
                    key={floor}
                    text={label}
                    removeRooms={this.props.deselectNumberOfRooms}
                    enableRoomRemove={isEditable}
                    rooms={rooms}
                  />
                );
              })}
            </div>
          </div>
          <div className="SelectedRoomsReviewSection__sections__individualRooms">
            <LabelV2>Individual Rooms</LabelV2>
            <div className="individualRooms__roomTypeGroups">
              {selectedRoomsGroupedByRoomTypeGroups.map(roomTypeGroup =>
                _.map(roomTypeGroup, (rooms, roomTypeGroupName) => (
                  <div
                    className="individualRooms__roomTypeGroups__group"
                    key="roomTypeGroupName">
                    <div>{roomTypeGroupName}</div>
                    <div className="individualRooms__roomTypeGroups__rooms">
                      {rooms.map(room => {
                        if (_.keys(room).length > 2) {
                          return (
                            <SelectedRoomReview
                              key={room.roomId}
                              text={room.roomNumber}
                              removeRooms={this.removeSingleRoom}
                              enableRoomRemove={isEditable}
                              rooms={room}
                            />
                          );
                        }
                        const text = `All rooms on floor ${room.floor}`;
                        return (
                          <SelectedRoomReview
                            key={roomTypeGroupName + room.floor}
                            text={text}
                            removeRooms={this.props.deselectNumberOfRooms}
                            enableRoomRemove={isEditable}
                            rooms={room.rooms}
                          />
                        );
                      })}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SelectedRoomsReviewSection;
